import API from 'services/API';

export default function getReadOnly() {
  return API.request({
    method: 'GET',
    url: '/profile/isReadOnly',
    mapper: function (data) {
      return data;
    },
  });
}
